/*
  Works only on primitives :D
*/
export const uniqueArray = <T>(items: T[]) => Array.from(new Set(items))
